import BlocksTable from "./BlockTable";
import DashboardLayout from "./layout/DashboardLayout";

const BlockTableComponent = () => {
  return (
    <DashboardLayout>
      <BlocksTable />
    </DashboardLayout>
  );
};

export default BlockTableComponent;
